// Function hit counts per instrumented file, keyed like window.__coverage__:
// { [absolute file path]: { [Istanbul function id]: hit count } }.
export type FnCounts = Record<string, Record<string, number>>;

declare global {
  interface Window {
    // Set by vite-plugin-istanbul in Cypress builds only (CYPRESS=true in vite.config.js).
    __coverage__?: unknown;
    __startupFnCounts__?: FnCounts;
  }
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const readFnCounts = (fileCoverage: unknown): Record<string, number> | undefined => {
  if (!isRecord(fileCoverage) || !isRecord(fileCoverage.f)) return undefined;
  return Object.fromEntries(
    Object.entries(fileCoverage.f).filter(
      (entry): entry is [string, number] => typeof entry[1] === 'number'
    )
  );
};

// Copies the Istanbul function counters into window.__startupFnCounts__. Call it once, before
// the first render, so the copy holds only the hits from module start-up (e.g. a page module's
// top-level `KEYS.filter(k => ...)`). The Cypress test-selection map counts a function for a
// spec only when it ran again after this point (see docs/CYPRESS.md "Test selection in CI").
// No-op outside Cypress builds.
export const snapshotStartupCoverage = () => {
  if (!window.Cypress || !isRecord(window.__coverage__)) return;

  const snapshot: FnCounts = {};
  for (const [file, fileCoverage] of Object.entries(window.__coverage__)) {
    const counts = readFnCounts(fileCoverage);
    if (counts) {
      snapshot[file] = counts;
    }
  }
  window.__startupFnCounts__ = snapshot;
};
